import mongoose, { Schema } from 'mongoose';
import {
  always,
  applySpec,
  compose,
  converge,
  nthArg,
  propOr,
} from 'ramda';
import { string } from '@555platform/utility-belt.js';
import { renameObjectKeys } from '../util';
import { query as queryModel } from './util';

const PingIDSchema = new Schema({
  className: { type: String },
  readAccess: [String],
  writeAccess: [String],
  ownerID: { type: String },
  createAt: { type: Date },
  updatedAt: { type: Date },
  fields: {
    app_key: { type: String },
    auth_string: { type: String },
    server_url: { type: String },
  },
});

const applyFieldScope = string.createTemplate('fields.${}');

// NOTE: AUM service will ensure indexeds
export const PingIDModel = () => mongoose.model(
  'pingidinfo',
  PingIDSchema,
  'PingIdInfo',
);

export const query = queryModel(PingIDModel);

PingIDSchema.statics.findByAppKey = compose(
  query('findOne'),
  applySpec({
    'fields.app_key': nthArg(0),
    ownerID: nthArg(1),
  }),
);

const now = () => new Date();

PingIDSchema.statics.upsert = converge(
  query('findOneAndUpdate'),
  [
    applySpec({ 'fields.app_key': propOr('__', 'app_key') }),
    applySpec({
      updatedAt: now,
      $setOnInsert: { ownerID: nthArg(1), createdAt: now },
      $set: renameObjectKeys(applyFieldScope),
    }),
    always({
      upsert: true,
      setDefaultsOnInsert: true,
      new: true,
    }),
  ],
);

export default PingIDModel;
